import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { getCoachesList } from '../../../services/adminApiService/batchManagementApi/BatchManagementApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import DistrictFilter from '../districtFilter/DistrictFilter';
import { LocationContext } from '../../../context/LocationContext';
import { useSport } from '../../../context/SportContext';
import SportFilter from '../sportFilter/SportFilter';
import TextMasked from '../../../utils/TextMasked';

const CoachesList = () => {
    const [coaches, setCoaches] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const { selectedDistrictId } = useContext(LocationContext);
    const { selectedSportId } = useSport();

    useEffect(() => {
        const fetchCoaches = async () => {
            setLoading(true);
            try {
                const response = await getCoachesList({
                    sports_id: selectedSportId || undefined,
                    district_id: selectedDistrictId || undefined,
                    limit: perPage,
                    page: currentPage,
                });
                setCoaches(response?.data?.data || []);
                setTotalPages(response?.data?.total_pages || 1);
            } catch (error) {
                console.error('Coaches list error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCoaches();
    }, [selectedSportId, selectedDistrictId, perPage, currentPage]);

    // No server-side search on /api/coaches — filter within the current page's results.
    const visibleCoaches = coaches.filter((data) => {
        const haystack = `${data?.name || ''} ${data?.email || ''} ${data?.mobile || ''}`.toLowerCase();
        return haystack.includes(searchValue.toLowerCase());
    });

    return (
        <>
            <PageTitle activeMenu="All Coaches" motherMenu="Dashboard" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1);
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    </div>
                    <div className="mx-4 d-flex mt-2">
                        <div>
                            <SportFilter setCurrentPage={setCurrentPage} />
                        </div>
                        <div className="ms-2">
                            <DistrictFilter setCurrentPage={setCurrentPage} />
                        </div>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact Number</th>
                                            <th>Sport Name</th>
                                            <th>District</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visibleCoaches.length > 0 ? (
                                            visibleCoaches.map((data, index) => {
                                                const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                return (
                                                    <tr key={data.id}>
                                                        <td>{serialNumber}</td>
                                                        <td>{data?.name}</td>
                                                        <td><TextMasked value={data?.email} type="email" /></td>
                                                        <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                        <td>{data?.sport_name}</td>
                                                        <td>{data?.district_name}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">Data is not available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={(e) => setCurrentPage(e.selected + 1)}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        </>
    )
}

export default CoachesList
